import styled, { keyframes } from 'styled-components';
import { fadeIn } from '../../constants/keyframes/fades';
import { withFancyScrollbar } from '../../constants/styleUtils/styleUtils';
import zIndex from '../../constants/zIndex';

const modalOpen = keyframes`
	0% { opacity: 0; transform: scale3d(1.1, 1.1, 1); }
	100% { opacity: 1; transform: scale3d(1, 1, 1); }
`;

export const Wrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	z-index: ${zIndex.modals};
	animation: ${modalOpen} 300ms;
`;

export const WrapperInner = styled.div`
	max-width: 95vw;
	max-height: 80vh;
	overflow-y: auto;
	overflow-x: hidden;
	${({ bigModal }) =>
		bigModal &&
		`
			max-width: 140rem;
			width: 100%;
		`}
	${withFancyScrollbar};
`;

export const ModalOverlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: -1;
	background-color: rgba(0, 0, 0, 0.6);
	animation: ${fadeIn} 300ms ease;
`;

export const ModalClose = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	padding: 3rem;
	border-radius: 4px;
	font-size: 2.5rem;
	color: #fff;
	cursor: pointer;
	transition: transform 200ms;

	&:hover {
		transform: scale(1.1);
	}
`;

export const WrapperV2 = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	overflow: auto;
	width: 100%;
	height: 100%;
	z-index: ${zIndex.modals};
	animation: ${modalOpen} 300ms;
`;

export const WrapperInnerV2 = styled.div`
	background-color: white;
	max-width: 95vw;
	max-height: 80vh;
	overflow-y: auto;
	overflow-x: hidden;
	${({ bigModal }) =>
		bigModal &&
		`
			max-width: 140rem;
			width: 100%;
		`}
	${withFancyScrollbar};
`;
